import { getConfig } from '../../config'
import { useCallback, useContext } from 'react'
import { PageContext } from '@contexts/page-context'
import { usePlacementContext } from '@contexts/placement-context'
import { waitGnar } from '@lib/utils/promise'
import { gnarSpec } from '@lib/tracking/gnar'
import { PlansCtaButton } from '@components/plans-cta-button'

export function FreeTrialButton() {
  const { placement, placementInternalName } = usePlacementContext()
  const { pageId, slug: pageSlug } = useContext(PageContext)
  const targetUrl = `${getConfig().urls.main}/plans`

  const onClick = useCallback(async () => {
    await waitGnar(
      gnarSpec.customLinkCtaButtonClick(
        'Anonymous Free Trial',
        pageId,
        pageSlug,
        targetUrl,
        placement,
        placementInternalName
      )
    )
  }, [placement, pageId, pageSlug, targetUrl, placementInternalName])

  return <PlansCtaButton variant="pro" size="medium" text="Try Pro for free" onClick={onClick} />
}
